import { render, staticRenderFns } from "./pathology-detail.vue?vue&type=template&id=a69abcde&scoped=true"
import script from "./pathology-detail.vue?vue&type=script&lang=js"
export * from "./pathology-detail.vue?vue&type=script&lang=js"
import style0 from "./pathology-detail.vue?vue&type=style&index=0&id=a69abcde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69abcde",
  null
  
)

export default component.exports